module.exports = "<button class=\"kd-button\"\r\n    ng-disabled=\"$ctrl.error\"\r\n    ng-click=\"$ctrl.generar = true\">Generar excel\r\n</button>\r\n<empresa-reportes-pld-excel-confirmacion\r\n    ng-if=\"$ctrl.generar\"\r\n    empresa-id=\"$ctrl.empresaId\"\r\n    data=\"$ctrl.data\"\r\n    on-close=\"$ctrl.generar = false\"></empresa-reportes-pld-excel-confirmacion>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/empresa/components/reportes/pld/excel/template.html
// module id = 2574
// module chunks = 0